import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EstadoOrdenMantenimientoService {

  private apiUrl = `${environment.apiUrl}/api/estados-orden-mantenimiento`;

  constructor(
    private http: HttpClient
  ) {}

  /**
   * Obtener todos los estados activos
   */
  getAll(): Observable<any> {
    return this.http.get<any>(this.apiUrl,  { withCredentials: true });
  }

  /**
   * Obtener estado por ID
   */
  getById(id: number): Observable<any> {
    return this.http.get<any>(
      `${this.apiUrl}/${id}`,
      { withCredentials: true }
    );
  }

  /**
   * Crear estado
   */
  create(data: any): Observable<any> {
    return this.http.post<any>(
      this.apiUrl,
      data,
      { withCredentials: true }
    );
  }

  /**
   * Actualizar estado
   */
  update(id: number, data: any): Observable<any> {
    return this.http.put<any>(
      `${this.apiUrl}/${id}`,
      data,
      { withCredentials: true }
    );
  }

  /**
   * Desactivar estado
   */
  delete(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      { withCredentials: true }     
    );
  }
}